import { render, staticRenderFns } from "./MPopupMailAuth.vue?vue&type=template&id=5197b32f&"
import script from "./MPopupMailAuth.vue?vue&type=script&lang=ts&"
export * from "./MPopupMailAuth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports